import { render, staticRenderFns } from "./BaseCrud.vue?vue&type=template&id=67240cf2&scoped=true&"
import script from "./BaseCrud.vue?vue&type=script&lang=js&"
export * from "./BaseCrud.vue?vue&type=script&lang=js&"
import style0 from "./BaseCrud.vue?vue&type=style&index=0&id=67240cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67240cf2",
  null
  
)

export default component.exports